import { useEffect, useState } from "react";
import { Button, Input, Table, Typography, message } from "antd";
import CreateUserModal from "./CreateUserModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp, faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { authService, UserResponse } from "../../services/authService";
import styles from "./settings.module.scss";
import moment from "moment";

const { Title } = Typography;

const TeamTab: React.FC = () => {
  const [users, setUsers] = useState<UserResponse[]>([]);
  const [loading, setLoading] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [search, setSearch] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchUsers(); }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {  if(!search) fetchUsers(); }, [search]);

  const fetchUsers = () => {
    const searchTerm = search ?? '';
    setLoading(true);
    authService.getUsers(searchTerm)
      .then((data: any) => setUsers(data?.data))
      .catch((e: any) => message.error(e?.response?.data?.message || e?.message || "Failed to load team members"))
      .finally(() => setLoading(false));
  };

  const handleSearch = () => {
    fetchUsers();
  }

  const columns = [
    { title: "LAST NAME", dataIndex: "lastName", key: "lastName" },
    { title: "FIRST NAME", dataIndex: "firstName", key: "firstName" },
    { title: "EMAIL", dataIndex: "email", key: "email" },
    {
      title: "LAST LOGIN",
      dataIndex: "lastLoginDate",
      key: "lastLoginDate",
      width: 200,
      render: (_: any, record: any) => (
        <Typography>{moment(record.lastLoginDate).format("MM/DD/YYYY")}</Typography>
      ),
      sorter: (a: any, b: any) => moment(a.lastLoginDate).valueOf() - moment(b.lastLoginDate).valueOf(),
      sortIcon: ({ sortOrder }: any) => {
        if (sortOrder === "ascend") return <FontAwesomeIcon icon={faArrowUp} />;
        if (sortOrder === "descend") return <FontAwesomeIcon icon={faArrowDown} />;
        return <></>;
      },
    },
    {
      title: "DATE CREATED",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      render: (_: any, record: any) => (
        <Typography>{moment(record.createdAt).format("MM/DD/YYYY")}</Typography>
      ),
      sorter: (a: any, b: any) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf(),
      sortIcon: ({ sortOrder }: any) => {
        if (sortOrder === "ascend") return <FontAwesomeIcon icon={faArrowUp} />;
        if (sortOrder === "descend") return <FontAwesomeIcon icon={faArrowDown} />;
        return <></>;
      },
    },
    { title: "CREATED BY", dataIndex: "createdBy", key: "createdBy" }
  ];


  return (
    <div className={styles.teamContainer}>
      <div className={styles.teamToolbar}>
        <div className={styles.teamToolbarLeft}>
          <Title level={5} className={styles.teamTitle}>Team</Title>
          <span className={styles.teamCount}>{users.length} Members</span>
        </div>
        <div className={styles.teamToolbarRight}>
          <Input
            placeholder="Search Team Members"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onPressEnter={handleSearch}
            style={{ width: 250, marginLeft: "auto", borderRadius: "50px" }}
            suffix={
              <FontAwesomeIcon
                icon={faSearch}
                onClick={handleSearch}
                style={{ cursor: "pointer" }}
              />
            }
          />
          <Button type="primary" icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => setCreateOpen(true)}>New User</Button>
        </div>
      </div>
      <Table
        className={styles.teamTable}
        columns={columns}
        dataSource={users}
        rowKey="id"
        loading={loading}
        locale={{ emptyText: "No team members found" }}
        pagination={false}
      />
      <CreateUserModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onSuccess={() => fetchUsers()}
      />
    </div>
  );
};

export default TeamTab;
